<template>
  <div>

    <transition appear
                @before-enter="$animations.beforeEnterLogoArea"
                @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns mb-0 is-centered">
        <div v-if="$root.selectedLanguage === `en`" class="column" style="text-align: center">
          <img
              src="../assets/images/icons/updatedIcons/normalFlow/documents.png"
              alt="document.png"
              width="85%"
          />
        </div>
        <div v-if="$root.selectedLanguage === `si`" class="column" style="text-align: center">
          <img
              src="../assets/images/icons/RBDSecondheaderImagesSin/Group 37575.png"
              alt="document.png"
              width="70%"
          />
        </div>
      </div>
    </transition>
    <div class=" card is-centered px-4 " style="width: 80%; margin: auto ">
    <transition appear
                @before-enter="$animations.beforeEnterAbove"
                @enter="$animations.enterAbove"
    >
      <div class="columns is-centered">
        <div class="column is-full ps-5" style="text-align: center">
          <img
              src="../assets/images/icons/Blue/Group 161.png"
              alt="document.img"
              width="70"
              height="70"
          />
          <p :class="`text-center mx-3 mb-2 texthead ${
              $root.selectedLanguage === `ta`
                ? `ta-he-line`
                : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
            }`"
             style="font-family: OpenSans-Bold; ">
            {{ $root.selectedLanguageData.documents }}
          </p>
          <p :class="`text-center mx-3 ${
              $root.selectedLanguage === `ta`
                ? `ta-sub-line`
                : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
            }`"
             style="font-family: OpenSans-Bold; "
          >
            {{ $root.selectedLanguageData.uploadtheseimagestoverify }}
          </p>
          <p style="font-family: OpenSans-Regular; font-size: 16px; ">
            {{ $root.selectedLanguageData.dataEditByButton }}
          </p>
        </div>
      </div>
    </transition>

    <ValidationObserver v-slot="{ invalid }">
      <form @submit.prevent="">
        <div class="columns is-centered">


          <div class="column is-8 pt-5 ps-5">

            <!--            Birth certificate image-->

            <div v-if="$root.formData.account ===`Minor Savings`">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"

              >
                {{ $root.selectedLanguageData.uploadimagesofBirthCertificate }}
              </label>
              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .noteUploadthebirthcertificateimagesMakesurethereisnoblurorglare
                }}
              </p>
              <div class="columns mt-2 is-7 is-variable">
                <div class="column is-one-two" >
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.birthCertificateFrontSideImage }}
                    <span class="has-text-danger">*</span></label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.birth_certificate_front_image
                    }"
                  >
                    <ValidationProvider
                        :rules="{ required: true, size: 1024, image: true }"
                        name="image"
                        v-slot="{ errors }"
                    >
                      <image-capture-component @on-captured="onBirthCertificateFrontCaptured" :crop_ratio=9/14 file_name="birth_certificate_front_image" :selectedImageURL="$root.imageurl.birth_certificate_front_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture" ></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="column is-one-two">
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.birthCertificateBackSideImage }}
                    <span class="has-text-danger">*</span></label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.birth_certificate_back_image,
                    }"
                  >
                    <ValidationProvider
                        :rules="{ required: true, size: 1024, image: true }"
                        name="image"
                        v-slot="{ errors }"
                    >
                      <image-capture-component  @on-captured="onBirthCertificateBackCaptured" :crop_ratio=14/9 file_name="birth_certificate_back_image" :selectedImageURL="$root.imageurl.birth_certificate_back_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
            </div>


            <!-- NIC Image -->
            <div>
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >
                {{ $root.selectedLanguageData.uploadimagesofNIC }}
              </label>
              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .noteUploadthenationalidentitycardimagesMakesurethereisnoblurorglare
                }}
              </p>
              <div class="columns mt-2 is-7 is-variable">
                <div class="column is-one-two" >
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.nicfrontsideimage }}
                    <span class="has-text-danger">*</span></label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.nic_front_image
                    }"
                  >
                    <ValidationProvider
                        :rules="{ required: true, size: 1024, image: true }"
                        name="Nic"
                        v-slot="{ errors }"
                    >
                      <image-capture-component v-if="$root.formData.idType === 'ONIC'" @on-captured="onNicCaptured" :crop_ratio=9/14 file_name="nic_front_image" :selectedImageURL="$root.imageurl.nicfrontsideimageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture" ></image-capture-component>
                      <image-capture-component v-if="$root.formData.idType === 'NNIC'" @on-captured="onNicCaptured" :crop_ratio=14/9 file_name="nic_front_image" :selectedImageURL="$root.imageurl.nicfrontsideimageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture" ></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="column is-one-two">
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                       : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.nicbacksideimage }}
                    <span class="has-text-danger">*</span></label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.nic_back_image,
                    }"
                  >
                    <ValidationProvider
                        :rules="{ required: true, size: 1024, image: true }"
                        name="image"
                        v-slot="{ errors }"
                    >
                      <image-capture-component  @on-captured="onNicBackCaptured" :crop_ratio=14/9 file_name="nic_back_image" :selectedImageURL="$root.imageurl.nicbacksideimageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
            </div>

            <div class="mt-3">
              <label v-if="$root.formData.haveNic === 'No' || $root.formData.account === `Minor Savings`" :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >
                {{$root.selectedLanguageData.uploadimagesofpassportminor }}
              </label>
              <label v-else :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >
                {{$root.selectedLanguageData.uploadimagesofpassport}}
              </label>
              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .noteUploadthefrontpageofyourdrivinglicenseMakesurethereisnoblurorglare
                }}
              </p>
              <div class="columns mt-2 is-7 is-variable">
                <div class="column is-one-two" >
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.passportbiopage }}
                    <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                  </label>
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.passport_bio_page_image
                    }"
                  >
                    <ValidationProvider
                        :rules="passportMandotoryValidate()"
                        name="Passport Bio Page"
                        v-slot="{ errors }"
                    >
                      <image-capture-component @on-captured="onPassportBioPageCaptured" :crop_ratio=16/10 file_name="passport_bio_page_image" :selectedImageURL="$root.imageurl.passport_bio_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture" ></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="column is-one-two">
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.passportalterationpage }}
                    <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
                  </label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.passport_alteration_page_image,
                    }"
                  >
                    <ValidationProvider
                        :rules="passportMandotoryValidate()"
                        name="Passport Alteration Page"
                        v-slot="{ errors }"
                    >
                      <image-capture-component  @on-captured="onPassportAlterationPageCaptured" :crop_ratio=16/10 file_name="passport_alteration_page_image" :selectedImageURL="$root.imageurl.passport_alteration_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
            </div>




            <!-- passport image -->
            <!--            <div class="mt-4">-->
            <!--              <label :class="`${-->
            <!--                    $root.selectedLanguage === `ta`-->
            <!--                      ? `ta-label`-->
            <!--                      : $root.selectedLanguage === `si`-->
            <!--                      ? `si-label`-->
            <!--                      : ``-->
            <!--                  }`" -->
            <!--                    >{{ $root.selectedLanguageData.uploadimagesofpassport }}-->
            <!--                    <span class="has-text-danger">*</span></label-->
            <!--                  >-->
            <!--              -->
            <!--              <p style="font-family: OpenSans-Regular; font-size: 16px">-->
            <!--                {{-->
            <!--                  $root.selectedLanguageData-->
            <!--                    .noteUploadthefrontpageofyourpassportMakesurethereisnoblurorglare-->
            <!--                }}-->
            <!--              </p>-->
            <!--              <b-field-->
            <!--                :class="{ 'has-name': !!$root.productImages.passport_image}"-->
            <!--              >-->
            <!--              <ValidationProvider-->
            <!--                        :rules="{ required: true, size: 1024, image: true }"-->
            <!--                        name="image"-->
            <!--                        v-slot="{ errors }"-->
            <!--                    >-->
            <!--                 <image-capture-component  class="imageCaptureComponent" @on-captured="onPassportCaptured" :crop_ratio=16/10 file_name="passport_image" :selectedImageURL="$root.imageurl.passportimageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>-->
            <!--                 <span class="has-text-danger">{{ errors[0] }}</span>-->

            <!--               </ValidationProvider>-->
            <!--              </b-field>-->
            <!--            </div>-->


            <!--            passport bio page and alteration page -->




            <!--            temp-->

            <!--            passport entry stamp page-->

            <div class="mt-4">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.passportentrystamppage }}
                <span class="has-text-danger" v-if="$root.formData.residentship === 'Non Resident'">*</span>
              </label
              >

              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .passportstampnote
                }}
              </p>
              <b-field
                  :class="{ 'has-name': !!$root.productImages.passport_entry_stamp_page_image}"
              >
                <ValidationProvider
                    :rules="passportMandotoryValidate()"
                    name="Guardian Passport Entry Stamp"
                    v-slot="{ errors }"
                >
                  <image-capture-component  class="imageCaptureComponent" @on-captured="onPassportStampPageCaptured" :crop_ratio=16/10 file_name="passport_entry_stamp_page_image" :selectedImageURL="$root.imageurl.passport_entry_stamp_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>

                </ValidationProvider>
              </b-field>
            </div>

            <!--            Driving Licence -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.uploadimageofdrivinglicence }}
                <!--                <span class="has-text-danger">*</span>-->
              </label>

              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .driving_licence_upload_note
                }}
              </p>
              <b-field
                  :class="{ 'has-name': !!$root.productImages.driving_licence_image}"
              >
                <ValidationProvider
                    :rules="{ required: true, size: 1024, image: true }"
                    name="Driving Licence"
                    v-slot="{ errors }"
                >
                  <image-capture-component  class="imageCaptureComponent" @on-captured=" onDrivingLicenceCaptured" :crop_ratio=14/9 file_name="driving_licence_image" :selectedImageURL="$root.imageurl.driving_licence_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>

                </ValidationProvider>
              </b-field>
            </div>


            <!--          guardian passport bio page and alteration page -->

            <div class="mt-3" v-if="$root.formData.account === `Minor Savings` || $root.formData.haveNic === 'No'">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >
                {{ $root.selectedLanguageData.uploadimagesofpassport }}
              </label>
              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .noteUploadthefrontpageofyourdrivinglicenseMakesurethereisnoblurorglare
                }}
              </p>
              <div class="columns mt-2 is-7 is-variable">
                <div class="column is-one-two" >
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.passportbiopage }}
                    <span class="has-text-danger" v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">*</span>
                  </label>
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.guardian_passport_bio_page_image
                    }"
                  >
                    <ValidationProvider
                        :rules="guardianPassportMandotoryValidate()"
                        name="Guardian Passport Bio Page"
                        v-slot="{ errors }"
                    >
                      <image-capture-component @on-captured="onGuardianPassportBioPageCaptured" :crop_ratio=16/10 file_name="guardian_passport_bio_page_image" :selectedImageURL="$root.imageurl.guardian_passport_bio_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture" ></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>

                <div class="column is-one-two">
                  <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
                  >{{ $root.selectedLanguageData.passportalterationpage }}
                    <span class="has-text-danger" v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">*</span>
                  </label
                  >
                  <b-field
                      :class="{
                      'has-name': !!$root.productImages.guardian_passport_alteration_page_image,
                    }"
                  >
                    <ValidationProvider
                        :rules="guardianPassportMandotoryValidate()"
                        name="Guardian Passport Alteration Page"
                        v-slot="{ errors }"
                    >
                      <image-capture-component  @on-captured="onGuardianPassportAlterationPageCaptured" :crop_ratio=16/10 file_name="guardian_passport_alteration_page_image" :selectedImageURL="$root.imageurl.guardian_passport_alteration_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-field>
                </div>
              </div>
            </div>


            <!--            temp-->

            <!--           Guardian passport entry stamp page-->

            <div class="mt-4" v-if="$root.formData.account === `Minor Savings` || $root.formData.haveNic === 'No'" >
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.passportentrystamppage }}
                <span class="has-text-danger" v-if="$root.formData.guardian_residency === 'Out of Sri Lanka'">*</span>
              </label
              >

              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .passportstampnote
                }}
              </p>
              <b-field
                  :class="{ 'has-name': !!$root.productImages.guardian_passport_entry_stamp_page_image}"
              >
                <ValidationProvider
                    :rules="guardianPassportMandotoryValidate()"
                    name="Guardian Passport Stamp Page"
                    v-slot="{ errors }"
                >
                  <image-capture-component  class="imageCaptureComponent" @on-captured="onGuardianPassportStampPageCaptured" :crop_ratio=16/10 file_name="guardian_passport_entry_stamp_page_image" :selectedImageURL="$root.imageurl.guardian_passport_entry_stamp_page_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>

                </ValidationProvider>
              </b-field>
            </div>



            <!-- selfie image -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.uploadyourselfieimage }}
                <span class="has-text-danger">*</span></label
              >

              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .noteUploadtheclearimageofyourselfMakesurethereisnoblurorglare
                }}
              </p>

              <b-field
                  :class="{ 'has-name': !!$root.productImages.selfie_image }"
              >
                <ValidationProvider
                    :rules="{ required: true, size: 1024, image: true }"
                    name="image"
                    v-slot="{ errors }"
                >
                  <image-capture-component class="imageCaptureComponent" @on-captured="onSelfieCaptured" :crop_ratio=1/1 file_name="selfie_image" :selectedImageURL="$root.imageurl.selfie_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>

            <!-- signature_image -->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.uploadyoursignatureimage}}
                <span class="has-text-danger">*</span></label
              >

              <p style="font-family: OpenSans-Regular; font-size: 16px">
                {{
                  $root.selectedLanguageData
                      .notepleasesignyoursignatureonawhitepaperandthentakeanimageofit
                }}
              </p>
              <b-field
                  :class="{ 'has-name': !!$root.productImages.sign_image }"
              >
                <ValidationProvider
                    :rules="{ required: true, size: 1024, image: true }"
                    name="image"
                    v-slot="{ errors }"
                >
                  <image-capture-component class="imageCaptureComponent" @on-captured="onSignatureCaptured" :crop_ratio=7/4 file_name="sign_image" :selectedImageURL="$root.imageurl.signature_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>

                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
            <!-- Visa Proof of the Country Residing -->
            <!--            <div-->
            <!--              class="mt-5"-->
            <!--              v-if="$root.formData.residentship === `Non Resident`"-->
            <!--            ><label :class="`${-->
            <!--                    $root.selectedLanguage === `ta`-->
            <!--                      ? `ta-label`-->
            <!--                      : $root.selectedLanguage === `si`-->
            <!--                      ? `si-label`-->
            <!--                      : ``-->
            <!--                  }`" -->
            <!--                    >{{ $root.selectedLanguageData.visa_proof_of_the_country_residing}}-->
            <!--                    </label-->
            <!--                  >-->
            <!--              <p style="font-family: OpenSans-Regular; font-size: 16px">-->
            <!--                {{-->
            <!--                  $root.selectedLanguageData-->
            <!--                    .take_a_picture_from_your_device_or_upload_an_already_available_picture-->
            <!--                }}-->
            <!--              </p>-->
            <!--              <b-field-->
            <!--                :class="{-->
            <!--                  'has-name': !!$root.productImages.visa_proof_doc,-->
            <!--                }"-->
            <!--              >-->
            <!--                <ValidationProvider-->
            <!--                  :rules="{ size: 1024, image: true }"-->
            <!--                  name="image"-->
            <!--                  v-slot="{ errors }"-->
            <!--                >-->

            <!--                  <image-capture-component class="imageCaptureComponent" @on-captured="onVisaProofCaptured" :crop_ratio=9/13 file_name="visa_proof_doc" :selectedImageURL="$root.imageurl.visa_proof_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>-->

            <!--                  <span class="has-text-danger">{{ errors[0] }}</span>-->
            <!--                </ValidationProvider>-->
            <!--              </b-field>-->
            <!--            </div>-->
            <div class="mt-5">
              <label :class="`${
                    $root.selectedLanguage === `ta`
                      ? `ta-label`
                      : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                  }`"
              >{{ $root.selectedLanguageData.uploadyourproofofaddress}}
                <span class="has-text-danger">*</span></label
              >
              <p
                  style="font-family: OpenSans-Regular; font-size: 16px; line-height: 24px;margin-bottom: 10px;"
              >
                {{
                  $root.selectedLanguageData
                      .notePleaseaddaphotoofanElectricityWaterorTelephonebillthatclearlyshowsyournameandresidentialaddress
                }}
              </p>
              <b-field>
                <b-checkbox
                    type="is-primary"
                    v-model="$root.formData.addressProofSameAsNic"

                    :disabled="!$root.imageurl.nicbacksideimageurl"
                ><p style="font-size: 0.9rem">{{
                    $root.selectedLanguageData.proofOfAddCheckBoxLine
                  }}</p></b-checkbox>
              </b-field>
              <b-field
                  :class="{
                  'has-name': !!$root.productImages.addr_proof_doc,
                }"
              >
                <ValidationProvider
                    :rules="{ required: true, size: 1024, image: true }"
                    name="image"
                    v-slot="{ errors }"
                >

                  <div style="border-radius: 10px; border: 1px solid black; padding: 10px" v-if="$root.formData.addressProofSameAsNic">
                    <a>
                      <b-image
                          :src="$root.imageurl.address_proof_imageurl"

                          responsive
                      ></b-image>
                    </a>
                  </div>
                  <div v-if="!$root.formData.addressProofSameAsNic"  >
                    <image-capture-component class="imageCaptureComponent" @on-captured="onAddressProofCaptured" :crop_ratio=16/9 file_name="addr_proof_doc" :selectedImageURL="$root.imageurl.address_proof_imageurl" :uploadButtonLabel="$root.selectedLanguageData.clickToUpload" :captureButtonLabel="$root.selectedLanguageData.capture"></image-capture-component>
                  </div>
                  <span class="has-text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-field>
            </div>
          </div>
        </div>

        <transition appear
                    @before-enter="$animations.beforeEnterBelow"
                    @enter="$animations.enterBelow"
        >
          <div class="columns mb-3 ">
            <div
                class="column is-6 is-offset-4 is-flex is-flex-direction-row-reverse "
            >

              <!--              @click="navigateToNextPage()"-->
              <!--              :disabled="$root.formData.account_type === `Personal Foreign Currency Account` ? !$root.productImages.nic_front_image || !$root.productImages.nic_back_image|| !$root.productImages.selfie_image || !$root.productImages.sign_image ||  !$root.productImages.passport_image  : !$root.productImages.nic_front_image || !$root.productImages.nic_back_image || !$root.productImages.selfie_image || !$root.productImages.sign_image "-->

              <!--              <b-button-->
              <!--           :disabled="!$root.productImages.nic_front_image || !$root.productImages.nic_back_image|| !$root.productImages.selfie_image || !$root.productImages.sign_image ||  !$root.productImages.passport_bio_page_image || !$root.productImages.passport_entry_stamp_page_image  || !$root.productImages.nic_front_image || !$root.productImages.nic_back_image || !$root.productImages.selfie_image || !$root.productImages.sign_image || !$root.productImages.passport_alteration_page_image"-->
              <!--              :class="`is-primary ${-->
              <!--                  $root.selectedLanguage === `ta`-->
              <!--                    ? `continue-button-ta`-->
              <!--                    : $root.selectedLanguage === `si`-->
              <!--                    ? `continue-button-si`-->
              <!--                    : `continue-button-en`-->
              <!--                }`"-->
              <!--                :loading="isContinueButtonLoading"-->
              <!--                @click="$router.push('preview-page')"-->


              <!--                >{{ $root.selectedLanguageData.continue }}</b-button-->
              <!--              >-->

              <!--
                            <b-button
                                :disabled="invalid ||!$root.productImages.nic_back_image || !$root.productImages.selfie_image || !$root.productImages.sign_image || !$root.productImages.addr_proof_doc || !isNotPassportRequired"
                                :class="`is-primary ${
                                $root.selectedLanguage === `ta`
                                  ? `continue-button-ta`
                                  : $root.selectedLanguage === `si`
                                  ? `continue-button-si`
                                  : `continue-button-en`
                              }`"
                                :loading="isContinueButtonLoading"
                                @click="submitPageInputs(isContinueButtonLoading, 'video-call-schedule', 'purpose', 'video-call-schedule', 1)"
                            >{{ $root.selectedLanguageData.continue }}</b-button>
              -->

              <b-button
                  :disabled="invalid ||!$root.productImages.nic_back_image || !$root.productImages.selfie_image || !$root.productImages.sign_image || !$root.productImages.addr_proof_doc || !isNotPassportRequired"
                  :class="`is-primary ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                  :loading="isContinueButtonLoading"
                  @click="navigateToNextPage()"
              >{{ $root.selectedLanguageData.continue }}</b-button>

              <b-button :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`" @click="$router.push('purpose')">{{
                  $root.selectedLanguageData.back
                }}</b-button>
            </div>
          </div>
        </transition>
      </form>
    </ValidationObserver>
    <GetHelp v-if="false"></GetHelp>
    </div>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import imageCaptureComponent from "@/components/supports/ImageCaptureComponent";
import {submitPageInputs} from "@/util/util";

export default {
  components: {
    GetHelp,
    Logo,
    imageCaptureComponent
  },
  data() {
    return {
      isContinueButtonLoading: false,
      nicFaceIdReceived : false,
      selfieFaceIdReceived : false,
      // these two variables are used to check if the faces are detected in the images
      nicFaceNotDetected : false,
      selfieFaceNotDetected : false,
      selfieFaceMaskDetected : false,
      nicFaceMaskDetected : false,
      isNotPassportRequired : true,
      submitPageInputs : submitPageInputs,


    };
  },

  //image url create
  watch: {

    "$root.productImages.birth_certificate_front_image": function () {
      if (this.$root.productImages.birth_certificate_front_image) {
        this.$root.imageurl.birth_certificate_front_imageurl = URL.createObjectURL(
            this.$root.productImages.birth_certificate_front_image
        );
      }
    },

    "$root.productImages.birth_certificate_back_image": function () {
      if (this.$root.productImages.birth_certificate_back_image) {
        this.$root.imageurl.birth_certificate_back_imageurl = URL.createObjectURL(
            this.$root.productImages.birth_certificate_back_image
        );
      }
    },
    "$root.productImages.passport_bio_page_image": function () {
      if (this.$root.productImages.passport_bio_page_image) {
        this.$root.imageurl.passport_bio_page_imageurl  = URL.createObjectURL(
            this.$root.productImages.passport_bio_page_image
        );
      }
    },

    "$root.productImages.guardian_passport_bio_page_image": function () {
      if (this.$root.productImages.guardian_passport_bio_page_image) {
        this.$root.imageurl.guardian_passport_bio_page_imageurl  = URL.createObjectURL(
            this.$root.productImages.guardian_passport_bio_page_image
        );
      }
    },

    "$root.productImages.passport_entry_stamp_page_image": function () {
      if (this.$root.productImages.passport_entry_stamp_page_image) {
        this.$root.imageurl.passport_entry_stamp_page_imageurl = URL.createObjectURL(
            this.$root.productImages.passport_entry_stamp_page_image
        );
      }
    },

    "$root.productImages.guardian_passport_entry_stamp_page_image": function () {
      if (this.$root.productImages.guardian_passport_entry_stamp_page_image) {
        this.$root.imageurl.guardian_passport_entry_stamp_page_imageurl = URL.createObjectURL(
            this.$root.productImages.guardian_passport_entry_stamp_page_image
        );
      }
    },

    "$root.productImages.passport_alteration_page_image": function () {
      if (this.$root.productImages.passport_alteration_page_image) {
        this.$root.imageurl.passport_alteration_page_imageurl = URL.createObjectURL(
            this.$root.productImages.passport_alteration_page_image
        );
      }
    },

    "$root.productImages.guardian_passport_alteration_page_image": function () {
      if (this.$root.productImages.guardian_passport_alteration_page_image) {
        this.$root.imageurl.guardian_passport_alteration_page_imageurl = URL.createObjectURL(
            this.$root.productImages.guardian_passport_alteration_page_image
        );
      }
    },

    "$root.productImages.driving_licence_image": function () {
      if (this.$root.productImages.driving_licence_image) {
        this.$root.imageurl.driving_licence_imageurl = URL.createObjectURL(
            this.$root.productImages.driving_licence_image
        );
      }
    },

    "$root.productImages.nic_front_image": function () {
      if (this.$root.productImages.nic_front_image) {
        this.$root.imageurl.nicfrontsideimageurl = URL.createObjectURL(
            this.$root.productImages.nic_front_image
        );
      }
    },
    "$root.productImages.nic_back_image": function () {
      if (this.$root.productImages.nic_back_image) {
        this.$root.imageurl.nicbacksideimageurl = URL.createObjectURL(
            this.$root.productImages.nic_back_image
        );
      }
    },
    "$root.productImages.passport_image": function () {
      if (this.$root.productImages.passport_image) {
        this.$root.imageurl.passportimageurl = URL.createObjectURL(
            this.$root.productImages.passport_image
        );
      }
    },
    "$root.productImages.selfie_image": function () {
      if (this.$root.productImages.selfie_image) {
        this.$root.imageurl.selfie_imageurl = URL.createObjectURL(
            this.$root.productImages.selfie_image
        );
      }
    },
    "$root.productImages.sign_image": function () {
      if (this.$root.productImages.sign_image) {
        this.$root.imageurl.signature_imageurl = URL.createObjectURL(
            this.$root.productImages.sign_image
        );
      }
    },
    "$root.productImages.visa_proof_doc": function () {
      if (this.$root.productImages.visa_proof_doc) {
        this.$root.imageurl.visa_proof_imageurl = URL.createObjectURL(
            this.$root.productImages.visa_proof_doc
        );
      }
    },
    "$root.productImages.addr_proof_doc": function () {
      if (this.$root.productImages.addr_proof_doc) {
        this.$root.imageurl.address_proof_imageurl = URL.createObjectURL(
            this.$root.productImages.addr_proof_doc
        );
      }
    },
    "$root.formData.addressProofSameAsNic": function () {
      if (this.$root.formData.addressProofSameAsNic) {
        this.$root.productImages.addr_proof_doc = this.$root.productImages.nic_back_image;
      }
      else{
        this.$root.productImages.addr_proof_doc = null;
        this.$root.imageurl.address_proof_imageurl= "";
      }
    },
  },

  methods: {
    onBirthCertificateFrontCaptured: function (e){
      this.$root.productImages.birth_certificate_front_image = e
      console.log("Birth certificate front image : "+this.$root.productImages.birth_certificate_front_image)
    },

    onBirthCertificateBackCaptured: function (e){
      this.$root.productImages.birth_certificate_back_image = e
      console.log("Birth certificate back image : "+this.$root.productImages.birth_certificate_back_image)
    },

    onPassportBioPageCaptured: function (e){
      this.$root.productImages.passport_bio_page_image = e
      console.log("Passport Bio Page : "+this.$root.productImages.passport_bio_page_image)
    },

    onGuardianPassportBioPageCaptured: function (e){
      this.$root.productImages.guardian_passport_bio_page_image = e
      console.log("Passport Bio Page : "+this.$root.productImages.guardian_passport_bio_page_image)
    },

    onDrivingLicenceCaptured: function (e){
      this.$root.productImages. driving_licence_image = e
      console.log("Driving Licence Image : "+ this.$root.productImages. driving_licence_image)
    },


    onPassportAlterationPageCaptured: function (e){
      this.$root.productImages.passport_alteration_page_image = e
      console.log("Passport Alteration Page : "+this.$root.productImages.passport_alteration_page_image)
    },

    onGuardianPassportAlterationPageCaptured: function (e){
      this.$root.productImages.guardian_passport_alteration_page_image = e
      console.log("Passport Alteration Page : "+this.$root.productImages.guardian_passport_alteration_page_image)
    },

    onPassportStampPageCaptured: function (e){
      this.$root.productImages.passport_entry_stamp_page_image = e
      console.log("Passport Stamp Page : "+this.$root.productImages.passport_entry_stamp_page_image)
    },

    onGuardianPassportStampPageCaptured: function (e){
      this.$root.productImages.guardian_passport_entry_stamp_page_image = e
      console.log("Passport Stamp Page : "+this.$root.productImages.guardian_passport_entry_stamp_page_image)
    },

    onNicCaptured: function (e){
      // alert(e)
      this.$root.productImages.nic_front_image = e
      console.log("NIC front image : "+this.$root.productImages.nic_front_image)
    },

    onNicBackCaptured: function (e){
      this.$root.productImages.nic_back_image = e
      console.log("NIC back image : "+this.$root.productImages.nic_back_image)
    },

    onSelfieCaptured: function (e){
      this.$root.productImages.selfie_image = e
      console.log("Selfie image : "+this.$root.productImages.selfie_image)
    },

    onSignatureCaptured: function (e){
      this.$root.productImages.sign_image = e
      console.log("Signature image : "+this.$root.productImages.sign_image)
    },

    onAddressProofCaptured: function (e){
      this.$root.productImages.addr_proof_doc = e
      console.log("Address proof image : "+this.$root.productImages.addr_proof_doc)
    },

    onPassportCaptured: function (e){
      this.$root.productImages.passport_image = e
      console.log("Passport image : "+this.$root.productImages.passport_image)
    },

    onVisaProofCaptured: function (e){
      this.$root.productImages.visa_proof_doc = e
      console.log("Visa proof image : "+this.$root.productImages.visa_proof_doc)
    },

    passportRequireChecker: function (){
      if (this.$root.formData.residentship === "Non Resident" && (!this.$root.productImages.passport_bio_page_image || !this.$root.productImages.passport_entry_stamp_page_image || !this.$root.productImages.passport_alteration_page_image)){
        this.isNotPassportRequired = false
      }
      else {
        this.isNotPassportRequired = true
      }
    },





    //validation
    validate() {
      const obj = {
        required: true,
      };
      return obj;
    },
    passportMandotoryValidate(){
      if (this.$root.formData.residentship === "Non Resident"){
        let obj = {
          required: true,
          size: 1024,
          image: true
        };
        return obj;
      }
    },

    guardianPassportMandotoryValidate(){
      if (this.$root.formData.guardian_residency === "Out of Sri Lanka"){
        let obj = {
          required: true,
          size: 1024,
          image: true
        };
        return obj;
      }
    },



    /**
     * A method to navigate to the next page --------------------------
     */
    navigateToNextPage() {
      const comp = this;
      console.log(this.$root.keyStrokeDynamics);

      console.log("Selfie image : "+comp.$root.productImages.selfie_image)




      // get face id details
      comp.getFaceIdDetails(comp.$root.productImages.nic_front_image, "nic");
      comp.getFaceIdDetails(comp.$root.productImages.selfie_image, "selfie");

      comp.checkFaceIdsReceived()


    },

    /**
     * This method is used to verify is the face id details are received --------------------------
     */
    checkFaceIdsReceived(){
      const comp = this

      if(!comp.nicFaceIdReceived || !comp.selfieFaceIdReceived){
        comp.isContinueButtonLoading = true
        setTimeout(this.checkFaceIdsReceived,100)
      }
      else{
        // TODO :: handle face not detected validation
        if(!comp.nicFaceNotDetected && !comp.selfieFaceNotDetected){
          console.log("selfieFaceMaskDetected",comp.selfieFaceMaskDetected)
          console.log("nicFaceMaskDetected",comp.nicFaceMaskDetected)
          if(!comp.selfieFaceMaskDetected && !comp.nicFaceMaskDetected){
            console.log("done")
            this.$router.push("video-call-schedule");

          }
        }
        comp.nicFaceIdReceived = false
        comp.selfieFaceIdReceived = false
        comp.isContinueButtonLoading = false
        comp.selfieFaceMaskDetected = false
        comp.nicFaceMaskDetected = false





        // if((!comp.nicFaceNotDetected) && (!comp.selfieFaceNotDetected) && (!comp.selfieFaceMaskNotDetected) && (!comp.nicFaceMaskNotDetected)){ // enable to continue if face is detected in nic front and selfie images
        //   //comp.submitForm()
        //   console.log("done")
        //   this.$router.push("video-call-schedule");
        //
        //
        // }
        // comp.nicFaceIdReceived = false
        // comp.selfieFaceIdReceived = false
        // comp.isContinueButtonLoading = false


        // this.$router.push("previewpage");
      }
    },

    /**
     *  A method to get face id details from images --------------------
     */
    async getFaceIdDetails(image, imageType) {
      const comp = this;
      var bodyFormData = new FormData();

      bodyFormData.append("image_file", image);
      // bodyFormData.append("kyc_token", this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12);
      let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
      comp.$http
          .post(this.$baseURL + "/kycForm/identifyFace", bodyFormData, {
            headers: { "Content-Type": "multipart/form-data","X-token":kyc_token },
          })
          .then(function (response) {
            console.log('Length',response.data.length);
            if (response.data.length > 0) {
              console.log("Recieved face id details --------------------");
              console.log(response);
              /* console.log('mask detected',response.data[0].maskDetected);
               console.log('mask detected',response.data[0]);*/
              var tmpFaceId = response.data[0].faceId;
              var maskDetectedValue = response.data[0][0].maskDetected;
              console.log('mask detedted',maskDetectedValue);

              console.log("-----------------------------------------");
              console.log("Image type : " +imageType +" Image : " + image +" Face ID value : " +tmpFaceId
              );
              let message = ''

              if (imageType === "nic" || imageType === "passport") {
                // if passed image is a NIC or Passport image
                comp.$root.formData.face_ids.nic = tmpFaceId;
                comp.nicFaceNotDetected = false
                if(maskDetectedValue == true) {
                  message = 'Mask detected in NIC image!'
                  comp.nicFaceMaskDetected = true
                  comp.$buefy.toast.open({
                    message: message+" Select another image",
                    type: "is-danger",
                  });
                }

              } else {
                // if passed image is selfie image
                comp.$root.formData.face_ids.selfie = tmpFaceId;
                comp.selfieFaceNotDetected = false
                if(maskDetectedValue == true) {
                  message = 'Mask detected in selfie image!'
                  comp.selfieFaceMaskDetected = true
                  comp.$buefy.toast.open({
                    message: message+" Select another image",
                    type: "is-danger",
                  });
                }
              }




            } else {

              // TODO :: complete face not detected validation

              let message = ''


              if(imageType === 'selfie'){
                message = 'No face detected in selfie image!'
                comp.selfieFaceNotDetected = true
              }
              /*else if(maskDetectedValue == true) {
                message = 'Mask detected in selfie image!'
                comp.selfieFaceNotDetected = true
              }*/
              else {

                message = 'No face detected in NIC front side image!'

                comp.nicFaceNotDetected = true
              }

              console.log("face not detected")

              comp.$buefy.toast.open({
                message: message+" Select another image",
                type: "is-danger",
              });

            }

            // enable each variable after face details received
            imageType === 'nic' ?  comp.nicFaceIdReceived = true : comp.selfieFaceIdReceived = true

          })
          .catch(function (response) {
            //handle error
            console.log(response);
          });
    },

    formatDate(date){
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate()

      if(month < 10){
        month = "0"+month;
      }
      let output = [month,day,year]
      return output.join("/")
    },
    updateLastStep() {
      try {
        window.element = this;
        let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12
        this.$http
            .post(this.$baseURL + "/kycForm/updateLastStep", {
              last_step_name:'Value Added Services',
              last_step: 6,
              form_filled:true,
              next_route:'Employment Info',
            },{
              headers:{'X-token':kyc_token}
            })
            .then((response) => {
              console.log(response.data);

              if (response.data.success) {
                console.log(response.data);
              } else {
                console.log(response.data);
              }
            }).catch((response) => {
          this.$buefy.toast.open({
            message: response.message,
            type: "is-danger",
          });
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed to update last step",
          type: "is-danger",
        });
      }
    },

    /**
     * This method is used to reset (initialize) the variables
     */
    resetVariables(){
      // initialize variables
      this.nicFaceIdReceived = false
      this.selfieFaceIdReceived = false
      this.isContinueButtonLoading = false
      this.nicFaceNotDetected = false
      this.selfieFaceNotDetected = false
      this.selfieFaceMaskDetected = false
      this.nicFaceMaskDetected = false

    },


  },
  mounted: function () {
    // this.updateLastStep();
    this.resetVariables()

  },
};
</script>
<style scoped>
.imageCaptureComponent{
  width: 60%;
  margin: auto;
}

.modal-card {
  border-radius: 0;
}

@media only screen and (max-width: 500px) {
  .texthead{
    font-size:2.5rem;
  }
}
</style>
